import type { IStrapiBanner } from './banners';
import type { ELinkType, ILink } from './links';
import type { EModalName } from './modals';
import type { ESsPlayerPaymentStatus } from './softswiss/ssPlayerPayments';
import type { IStrapiImage } from './strapiImage';

export interface IManagerData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  name: string;
  bannerComplex: IStrapiBanner;
  locale: string;
}

export interface IManagersStrapiResponse {
  data: IManagerData[];
}

export enum ENotificationType {
  notification_personal = 'notification_personal',
  notification_group = 'notification_group',
}

export enum ENotificationSettingsType {
  Bonuses = 'bonuses',
  CashOut = 'cash_out',
  Compoints = 'compoints',
  ConfirmEmail = 'confirm_email',
  DepositInfo = 'deposit_info',
  Freespins = 'freespins',
  LevelUp = 'level_up',
  Notification = 'notification',
  Welcome = 'welcome',
}

export type INotificationsStatusWorker = Record<
  string,
  {
    timestamp: number | string | null;
    type: string | null;
    readed: boolean;
  }
>;

export interface INotificationsStatus {
  player_id: number;
  type: ENotificationType | EModalName;
  record_id: number;
}

export interface INotificationFeedElement {
  id: string;
  type: ENotificationSettingsType;
  readed: boolean;
  timestamp: number;
  action?: {
    type: ELinkType;
    modal: EModalName;
    params: { [key: string]: string };
  };
  data: {
    icon: IStrapiImage | null;
    typeTitle: string;
    title: string;

    banner?: IStrapiBanner | null;
    messageText?: string;
    vipMessageText?: string;
    status?: string;
    statusId?: ESsPlayerPaymentStatus;
  };
}

export interface INotificationPersonal {
  id: number;
  manager: IManagerData;
  playerId: string;
  title: string;
  bonusCode?: string;
  messageText: string;
  buttons?: ILink[];
  createdAt?: Date;
  locale: string;
}

export interface INotificationGroupEssential {
  id: number;
  groupIds: string;
  title: string;
  bonusCode?: string;
  messageText: string;
  managerId: number;
  buttons?: ILink[];
  createdAt?: Date;
  locale: string;
}

export interface INotificationGroup extends INotificationGroupEssential {
  manager: IManagerData;
}

export interface INotificationsStrapiResponse {
  data: INotificationGroupEssential[];
}

export interface INotificationCommon {
  id: string;
  manager: IManagerData;
  playerId?: string;
  groupIds?: string;
  bonusCode?: string;
  title: string;
  messageText: string;
  buttons?: ILink[];
  createdAt?: Date;
  locale: string;
}

export interface INotificationSettings {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  type: ENotificationSettingsType;
  typeTitle: string;
  icon?: IStrapiImage;
  bannerComplex?: IStrapiBanner;
  locale: string;
}

export interface INotificationSettingsStrapiResponse {
  data: INotificationSettings[];
}

export interface INotificationWelcome {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  publishedAt?: Date;
  title: string;
  messageText: string;
  bonusCode?: string;
  groupIds: string;
  button?: ILink;
  customButtonName?: string;
  hideGroupId: string;
  typeTitle: string;
  bannerComplexNotification?: IStrapiBanner;
  locale: string;
}

export interface INotificationWelcomeStrapiResponse {
  data: INotificationWelcome[];
}
